import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { AddPsychiatryOnlyUtmSourceParams, adminAddPsychiatryOnlyUtmSources, adminGetPsychiatryOnlyUtmSources, adminUpdatePsychiatryOnlyUtmSource, getPatientPsychiatryOnlyUtmSource, getPsychiatryOnlyUtmSources, UpdatePsychiatryOnlyUtmSourceParams } from '@uplift/api';

import { BaseSuspenseQueryOpts } from './baseTypes';

export const usePsychiatryOnlyUtmSourcesQuery = (opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'psychiatryOnly', 'utmSources' ],
    queryFn: getPsychiatryOnlyUtmSources,
    select: (res) => res.data,
    staleTime: Infinity,
    retry: 1,
    ...opts,
  });
};


export const usePatientPsychiatryOnlyUtmSourceQuery = (patientId: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'psychiatryOnly', 'utmSources', { patientId } ],
    queryFn: () => getPatientPsychiatryOnlyUtmSource(patientId),
    select: (res) => res.data,
    staleTime: Infinity,
    retry: 1,
    ...opts,
  });
};


export const useAdminPsychiatryOnlyUtmSourcesQuery = (opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'psychiatryOnly', 'utmSources', 'list' ],
    queryFn: adminGetPsychiatryOnlyUtmSources,
    select: (res) => res.data,
    staleTime: Infinity,
    retry: 1,
    ...opts,
  });
};


export const useAdminAddPsychiatryOnlyUtmSourcesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: AddPsychiatryOnlyUtmSourceParams) => {
      await adminAddPsychiatryOnlyUtmSources(params);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({
        queryKey: [ 'psychiatryOnly', 'utmSources' ]
      });
    }
  });
};


export const useAdminUpdatePsychiatryOnlyUtmSourceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdatePsychiatryOnlyUtmSourceParams) => {
      await adminUpdatePsychiatryOnlyUtmSource(params);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({
        queryKey: [ 'psychiatryOnly', 'utmSources' ]
      });
    }
  });
};
